import axios from 'axios';
import qs from 'qs'
import http from './config';

let base = http.src;
// request拦截器
axios.interceptors.request.use(
	config => {
	//   if (getToken()) {
		config.headers["Authorization"] = "Bearer " + sessionStorage.getItem('token'); // 让每个请求携带自定义token 请根据实际情况自行修改
	//   }
	  return config;
	},
	error => {
	  console.log(error);
	  Promise.reject(error);
	}
);
  

//专业类别--列表数据
export const majorTypeList = params => {
	return axios.get(`${base}/admin/professional/list`,  {
		params: params
	}).then(res => res.data)
}
//专业类别--获取指定的专业类别详情
export const getMajorDetail = params => {
	return axios.get(`${base}/admin/professional/get/${params}`).then(res => res.data)
}
//专业类别--删除指定的专业类别
export const deleteMajorDetail = params => {
	return axios.delete(`${base}/admin/professional/delete/${params}`).then(res => res.data)
}
//专业类别--添加或者修改专业类别
export const addMajorDetail = params => {
	return axios.post(`${base}/admin/professional/addOrUpdate`,params).then(res => res.data)
}

//学员信息--列表数据
export const studentList = params => {
	return axios.get(`${base}/admin/student/list`,{
		params: params
	}).then(res => res.data)
}
//学员信息--获取指定的学员信息
export const getStudentDetail = params => {
	return axios.get(`${base}/admin/student/get/${params}`).then(res => res.data)
}
//学员信息--结业
export const graduationStudent = params => {
	return axios.put(`${base}/admin/student/complete`,params).then(res => res.data)
}
//报名记录--列表数据
export const applicationFormList = params => {
	return axios.get(`${base}/admin/applicationForm/list`,{
		params: params
	}).then(res => res.data)
}
//报名记录--列表增加备注
export const updateMark = params => {
	return axios.put(`${base}/admin/applicationForm/updateMark`,params).then(res => res.data)
}
//报名记录--审核通过或者驳回
export const examOrBack = params => {
	return axios.put(`${base}/admin/applicationForm/underwrite`,params).then(res => res.data)
}
//报名记录--查询报名记录详细信息
export const getSignUpDetail = params => {
	return axios.get(`${base}/admin/applicationForm/getId/${params}`).then(res => res.data)
}

//报名记录--报表导出
export const exportExcel = params => {
	return axios.get(`${base}/admin/applicationForm/list/excel`,params).then(res => res.data)
}

//会员单位管理--列表数据
export const companyList = params => {
	return axios.get(`${base}/admin/vipCompany/list`,{
		params: params
	}).then(res => res.data)
}
//会员单位管理--删除会员单位
export const deleteCompany = params => {
	return axios.delete(`${base}/admin/vipCompany/delete/${params}`).then(res => res.data)
}

//会员单位管理--查看会员公司详细信息
export const getDetailCompany = params => {	
	return axios.get(`${base}/admin/vipCompany/get/${params}`).then(res => res.data)
}
//会员单位管理--添加或者更新会员公司
export const addCompany = params => {	
	return axios.post(`${base}/admin/vipCompany/addOrUpdate`,params).then(res => res.data)
}

//登录接口
export const login = params => {	
	return axios.post(`${base}/admin/login`,params).then(res => res.data)
}
//企业更变记录--列表数据
export const companyChangeList = params => {
	return axios.get(`${base}/admin/change/list`,{
		params: params
	}).then(res => res.data)
}
//企业更变记录--企业更变确认
export const companyChangeConfirm = params => {
	return axios.put(`${base}/admin/change/affirm`,params).then(res => res.data)
}
//企业更变记录--企业更变详情
export const getCompanyDetail = params => {
	return axios.get(`${base}/admin/change/get/${params}`).then(res => res.data)
}
//发票管理--发票申请记录
export const getBillList = params => {
	return axios.get(`${base}/admin/invoice/list`,{
		params: params
	}).then(res => res.data)
}
//发票管理--发票详细信息
export const getBillDetail = params => {
	return axios.get(`${base}/admin/invoice/getId/${params}`,).then(res => res.data)
}
//发票管理--填写单号
export const fillBill = params => {
	return axios.put(`${base}/admin/invoice/update`,params).then(res => res.data)
}
//支付流水--获取列表数据
export const getPayList = params => {
	return axios.get(`${base}/admin/pay/list`,{
		params: params
	}).then(res => res.data)
}
//费用设置
export const moneySet = params => {	
	return axios.post(`${base}/admin/fee/setting`,params).then(res => res.data)
}
//获取费用
export const getMoneySet = params => {	
	return axios.get(`${base}/admin/fee/info`).then(res => res.data)
}
//上传图片
export const uploadMaterial = params => {	
	return axios.post(`${base}/api/v1/uploadMaterial`,params).then(res => res.data)
}
//报名记录修改数据
export const appInfo = params => {	
	return axios.post(`${base}/admin/update/appInfo`,params).then(res => res.data)
}
//批量下载数据
export const PersonImages = params => {	
	return axios.post(`${base}/admin/download/PersonImages`,params).then(res => res.data)
}
//修改学时
export const period = params => {	
	return axios.post(`${base}/admin/update/period`,params).then(res => res.data)
}
//更新照片
export const personImg = params => {	
	return axios.post(`${base}/api/v1/update/personImg`,params).then(res => res.data)
}
//获取模板url
export const templateUrl = params => {	
	return axios.get(`${base}/admin/import/student/template`).then(res => res.data)
}
//获取技术数据
export const getBaseData = params => {	
	return axios.get(`${base}/api/v1/base/code?codeType=${params.type}`).then(res => res.data)
}

//获取考核记录 
export const getExmaList = params => {	
	return axios.get(`${base}/admin/exam/list`,{params:params}).then(res => res.data)
}

//新增考核记录
export const addExam = params => {	
	return axios.post(`${base}/admin/add/exam`,params).then(res => res.data)
}
//修改考核记录
export const editExam = params => {	
	return axios.post(`${base}/admin/update/exam`,params).then(res => res.data)
}
//删除考核记录
export const deleteExam = params => {	
	return axios.post(`${base}/admin/delete/exam`,params).then(res => res.data)
}

//报名记录--删除报名记录
export const deleteStudentBill = params => {	
	return axios.post(`${base}/admin/delete/applicationForm`,params).then(res => res.data)
}
//学员信息--批量修改学时
export const mulChangePeriod= params => {	
	return axios.post(`${base}/admin/batch/update/period`,params).then(res => res.data)
}
//学员信息 -- 导出成绩模板 /admin/export/exam/excel   applicationFormIds  数组
export const exportGradeTempalte = params => {	
	return axios.post(`${base}/admin/export/exam/excel`,params).then(res => res.data)
}
//学员信息 -- 提交导入的成绩 /admin/submit/exam 
export const submitGradeList = params => {	
	return axios.post(`${base}/admin/submit/exam`,params).then(res => res.data)
}
// 学员信息 -- 注销学员信息 /admin/submit/exam  /admin/delete/student
export const cancelStudentInfomation= params => {	
	return axios.post(`${base}/admin/delete/student`,params).then(res => res.data)
}
//学员信息--注销学员列表数据 /admin/student/del/log/list
export const getCancelList= params => {	
	return axios.get(`${base}/admin/student/del/log/list`,{params:params}).then(res => res.data)
}
//修改学时和培训时间
export const studentUpdate = params => {
	return axios.put(`${base}/admin/student/update`,params).then(res => res.data)
}
//更新支付流水备注
export const noteUpdate = params => {	
	return axios.put(`${base}/admin/update/note`,params).then(res => res.data)
}